import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IScheduledDedupeSettings } from '../interfaces/ischeduled-dedupe-settings';

@Injectable({
  providedIn: 'root'
})
export class ScheduledMergesService {
  days = [1, 2, 3, 4, 5, 6, 7];
  changesMade: Subject<boolean>;

  scheduledDedupeSettings: IScheduledDedupeSettings;

  constructor(
    private http: HttpClient
  ) {
  }

  getScheduledDedupeSettingsForCorp(corpId?: number): Observable<IScheduledDedupeSettings> {
    return this.http.get<any | IScheduledDedupeSettings>(
      // tslint:disable-next-line:max-line-length
      `${environment.duplikitUrl}/ScheduledDedupeSettings/getScheduledDedupeSettingsForCorp?${corpId ? `corpId=${corpId}` : ''}`)
      .pipe(
        map((res) => {
          const result: IScheduledDedupeSettings = {
            corpId: res.corpId,
            enabled: res.enabled,
            enabledEntities: [],
            enabledDays: [],
            mergeTimeUTC: res.mergeTimeUTC,
            batchSize: res.batchSize
          };

          for (const entity of ['Candidate', 'ClientContact', 'ClientCorporation']) {
            result.enabledEntities[entity] = res.enabledEntities.indexOf(entity) > -1;
          }

          for (let i = 1; i < 8; i++) {
            result.enabledDays[i.toString()] = res.enabledDays.indexOf(i.toString()) > -1;
          }

          return result;
        })
      );
  }

  getEnabledEntitiesAsString(): string {
    const enabledEntities = [];

    for (const entity of ['Candidate', 'ClientContact', 'ClientCorporation']) {
      if (this.scheduledDedupeSettings.enabledEntities[entity])
        enabledEntities.push(entity);
    }

    return enabledEntities.join(',');
  }

  getEnabledDaysAsString(): string {
    const enabledDays = [];

    for (const day of this.days) {
      if (this.scheduledDedupeSettings.enabledDays[day])
        enabledDays.push(day);
    }

    return enabledDays.join(',');
  }
}
